export default __webpack_public_path__ + "locales/vi/Common.json?hash=674a347068c206ada58df13c5d5ca090";